import { useParams } from "react-router-dom";
import { faLessThan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const EditUser = () => {
  const userId = useParams();
  const id = Object.values(userId);
  const Navigator = useNavigate();

  const [userData, setUserData] = useState({
    name: "",
    email: "",
    password: "*****",
    role: "",
  });
  const handleInput = (e) => {
    e.preventDefault();

    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("/user/add", userData);
      if (response.data.status === 401) {
        toast.error(response.data.validator_error.email[0], {
          closeOnClick: true,
          theme: "colored",
        });
      } else if (response.data.status === 200) {
        setUserData({ name: "", email: "", password: "", role: "" });
        toast.success(response.data.message, {
          closeOnClick: true,
          theme: "colored",
        });
      } else {
        console.log(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchuser = async () => {
    try {
      const response = await axios.get(`/user/edit/${id}`);
      if (response.data.status === 200) {
        setUserData(response.data.user);
      } else {
        console.log(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchuser();
  }, []);

  return (
    <div className="container">
      <div className="card">
        <div className="card-header admin-bg-primary text-white">
          <h4>
            Edit User
            <button
              className="float-end btn btn-secondary"
              onClick={() => Navigator("/admin/users")}
            >
              <FontAwesomeIcon icon={faLessThan} /> Back
            </button>
          </h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group mb-3">
              <label>Name</label>
              <input
                type="text"
                name="name"
                className="form-control"
                onChange={handleInput}
                required
                value={userData.name}
              />
            </div>

            <div className="form-group mb-3">
              <label>Email</label>
              <input
                type="email"
                name="email"
                className="form-control"
                onChange={handleInput}
                value={userData.email}
                required
              />
            </div>

            <div className="form-group mb-3">
              <label>Password</label>
              <input
                type="password"
                name="password"
                className="form-control"
                onChange={handleInput}
                value={userData.password}
                required
                autoComplete="off"
              />
            </div>

            <div className="form-group mb-3">
              <label>Role</label>
              <select
                className="form-control"
                name="role"
                onChange={handleInput}
                value={userData.role}
              >
                <option value="">select Role</option>
                <option value="1">Admin</option>
                <option value="0">User</option>
              </select>
            </div>

            <div className="form-group mb-3">
              <input type="submit" value="Update" className="btn btn-primary" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditUser;
